import Vue from 'vue'
import Router from 'vue-router'

import Insights from './app/models/Insights'

Vue.use(Router)

let _router = new Router({
	routes:[
		{
			path: '/',
			redirect: '/enrollment'
		},
		{	//https://stackoverflow.com/questions/40193634/vue-router-redirect-on-page-not-found-404
			path: '/loading',
			component:()=>import(/* webpackChunkName: "view-loading" */'./app/views/Route.Loading.vue'),
			meta:{
				title:'Pioneer Insights Internal Reports: Loading'
			}
		},
		{	//https://stackoverflow.com/questions/40193634/vue-router-redirect-on-page-not-found-404
			path: '/503',
			component:()=>import(/* webpackChunkName: "view-503" */'./app/views/Route.503.vue'),
			meta:{
				title:'Pioneer Insights Internal Reports: Not available'
			}
		},
		{	//https://stackoverflow.com/questions/40193634/vue-router-redirect-on-page-not-found-404
			path: '/404',
			component:()=>import(/* webpackChunkName: "view-404" */'./app/views/Route.404.vue'),
			meta:{
				title:'Pioneer Insights Internal Reports: Page not found'
			}
		},
		{
			path: '/:level01/:level02?/:level03?',
			name: 'segment',
			component:()=>import(/* webpackChunkName: "view-segment" */'./app/views/Route.Segment.vue'),
			props:{
				Insights
			},
			meta:{
				title:"Pioneer Insights" + ((Insights.app.mode === "operations") ? ": Internal Reports" : ""),
				metaTags: [
					{
						name: 'description',
						content: 'The Cal State East Bay Pioneer Insights page.'
					},
					{
						property: 'og:description',
						content: 'The Cal State East Bay Pioneer Insights page.'
					}
				]
			}
		}
	]
});

_router.beforeEach((to,from,next)=>{
	let path = to.path;
	let q_params = to.query;
	let redirect_paths = ['/loading','/503','/404'];

	if(!Insights.app.landingPath){
		Insights.app.landingPath = path;
	}

	//Change the document title
	document.title = to.meta.title;
	
	//This guard is here to avoid a stack overflow
	if(redirect_paths.indexOf(path) > -1){
		next();
	} else {
		//All internal state is managed by Insights
		if(Insights.app.loaded){
			//Digest the path and, if successful, move on
			let success = Insights.digest(path, q_params);
			if(!success){
				//Path not found; re-route to 404
				next('/404');
			} else {
				//Navigate: next() must be called for route completion 
				next();
			}
		} else {
			//Insights isn't loaded yet
			next('/loading');
		}

	}
});

export default _router